import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDataTable,{staticClass:"elevation-1",attrs:{"items":_vm.data,"headers":_vm.headers,"loading":_vm.loading,"server-items-length":_vm.paginator.total,"footer-props":_vm.footerProps,"hide-default-footer":_vm.hideDefaultFooter},scopedSlots:_vm._u([{key:"item.options",fn:function({ item }){return [_c(VBtn,{attrs:{"text":""},on:{"click":function($event){return _vm.$emit('rowClicked', item)}}},[_c(VIcon,[_vm._v("mdi-eye")])],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }